import { Layout, GapBacktestShortlist, LivePaperTrading, PaperTradingSettings, DayReview, Watchlist, DataQuality, ParamOptimizer, StockUniverse, StrategyConfig } from '@/views/gap-backtest';

export default {
    path: '/gap-backtest',
    component: Layout,
    children: [
        { path: 'shortlist', component: GapBacktestShortlist },
        { path: 'live', component: LivePaperTrading },
        { path: 'settings', component: PaperTradingSettings },
        { path: 'day-review', component: DayReview },
        { path: 'watchlist', component: Watchlist },
        { path: 'data-quality', component: DataQuality },
        { path: 'param-optimizer', component: ParamOptimizer },
        { path: 'universe', component: StockUniverse },
        { path: 'strategy-config', component: StrategyConfig },
    ]
};
